import { FeatureFlag, isFeatureEnabled } from "store/featureFlagsSlice"
import { useAppSelector } from "store/hooks"
import { ContractorUserRole } from "types/ContractorUserEnum"
import { ReactComponent as IconDevice } from "assets/svg/icon-device.svg"
import { ReactComponent as IconAlerts } from "assets/svg/menu-alerts.svg"
import { ReactComponent as IconCustomers } from "assets/svg/menu-customers.svg"
import { ReactComponent as IconDashboard } from "assets/svg/menu-dashboard.svg"
import { ReactComponent as IconIntelligenceReports } from "assets/svg/menu-intelligence.svg"
import { ReactComponent as IconMessages } from "assets/svg/menu-messages.svg"
import { ReactComponent as IconMonitoring } from "assets/svg/menu-monitoring.svg"
import { ReactComponent as IconOrders } from "assets/svg/menu-orders.svg"
import { ReactComponent as IconPerformance } from "assets/svg/menu-performance.svg"

import { useNewOrdersQuantity } from "hooks/useNewOrdersQuantity"

import { MenuBadge, MenuItem, MenuItemGroup, MenuSubItem } from ".."

export const ContractorMenu = () => {
  const userProfile = useAppSelector(state => state.user.userProfile)
  const isTechnician = userProfile?.type === ContractorUserRole.TECHNICIAN
  const showSensors = useAppSelector(isFeatureEnabled(FeatureFlag.SensorsOrdering))
  const showAlertRules = useAppSelector(isFeatureEnabled(FeatureFlag.AlertRules))
  const showAdHocReports = useAppSelector(isFeatureEnabled(FeatureFlag.AdHocReports))
  const { data } = useNewOrdersQuantity({ enabled: !isTechnician })

  return (
    <>
      {!isTechnician && <MenuItem to="/dashboard" icon={<IconDashboard />} label="Dashboard" />}
      {!isTechnician &&
        (showSensors ? (
          <MenuItemGroup icon={<IconDevice />} label="Devices" basePaths={["/devices"]}>
            <MenuSubItem to="/devices" label="Thermostats" />
            <MenuSubItem to="/devices/sensors" label="Sensors" />
          </MenuItemGroup>
        ) : (
          <MenuItem to="/devices" icon={<IconDevice />} label="Devices" />
        ))}

      <MenuItem to="/customers" icon={<IconCustomers />} label="Customers" />

      {!isTechnician && (
        <MenuItem
          to="/orders"
          icon={<IconOrders />}
          label="Orders"
          badge={<MenuBadge count={data?.data?.quantity} />}
        />
      )}

      {!isTechnician && <MenuItem to="/messages" icon={<IconMessages />} label="Messages" />}

      <MenuItem to="/alerts" icon={<IconAlerts />} label="Alerts" />

      {!isTechnician && (
        <MenuItem to="/perf-test" icon={<IconPerformance />} label="Performance Test" iconType="stroke" />
      )}

      {showAlertRules ? (
        <MenuItemGroup icon={<IconMonitoring />} label="Monitoring" basePaths={["/monitoring"]}>
          <MenuSubItem to="/monitoring" label="Monitoring Page" />
          <MenuSubItem to="/monitoring/alert-rules" label="Alert Rules" />
        </MenuItemGroup>
      ) : (
        <MenuItem icon={<IconMonitoring />} to="/monitoring" label="Monitoring" />
      )}

      <MenuItemGroup
        icon={<IconIntelligenceReports />}
        label="Reports"
        basePaths={["/intelligence-reports", "/ad-hoc-reports"]}
      >
        <MenuSubItem to="/intelligence-reports" label="Intelligence Reporting" />
        {showAdHocReports && <MenuSubItem to="/ad-hoc-reports" label="On-Demand Reports" />}
      </MenuItemGroup>
    </>
  )
}
